import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { HistoryManager } from "../../Managers/HistoryManager";
import { ApplicationData } from "../ApplicationData";
import { BaseView } from "../views/BaseView";
import { clearAccountData, clearSearchHistory } from "src/main/resources/js/lib/util/clearSensitiveSessionData";
import { axios } from "@tlc/ls2pac/components/AxiosInstanceManager";
import { isAxiosError } from "axios";

export const LoginClientManager = (function () {

	var currentLoginCallback;
	var currentCloseCallback;

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onLogin, function (event) {
		_onLogin(event.credentials);
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onCloseLogin, function (event) {

		if (event.closedViaSubmit === true) {
			if (currentLoginCallback) {
				currentLoginCallback(AccountHolder.currentData.user);
			}
			currentCloseCallback = null;
			currentLoginCallback = null;
		}
		else {
			if (currentCloseCallback) {
				currentCloseCallback(event.prevPath);
			}
			currentCloseCallback = null;
			currentLoginCallback = null;
		}

	});

	var _onLogin = function (credentials) {
		var postData = {};

		for (var key in credentials) {
			var prop = (key == "barcode") ? "username" : key;
			postData[prop] = credentials[key];
		}

		var rememberMe = credentials.rememberMe;

		var onLoginResponse = {};
		TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.login + (rememberMe !== undefined ? '?rememberMe=' + rememberMe : ''), {
			waitOnOtherRequests: true,
			postData: postData,
			callback: function (response) {
				onLoginResponse = response;
				TLCLogger.log("login response", onLoginResponse);
			},
			finallyHandler: async function () {
				if (onLoginResponse.success) {
					if (postData.linkGoogleAccount === "true") {
						window.location = '/oauth2/linkAccount';
					} else {
						const { user } = await AccountHolder.fetchAccountData(true); // populate all account data, not just user
						TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onLoginResponse, {
							success: onLoginResponse.success,
							response: onLoginResponse
						});
					}
				} else {
					TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onLoginResponse, {
						success: onLoginResponse.success,
						response: onLoginResponse
					});
				}
			}
		});
	};

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onLogout, function (event) {
		_onLogout(event.callback, event.clearHistory);
	});

	var _onLogout = function (callback, clearHistory) {
		clearHistory = (clearHistory == undefined) ? true : clearHistory;
		var success = false;

		if (ApplicationData.locationConfiguration.isADFSEnabled()) {
			location.href = ApplicationData.locationConfiguration.getADFSLogoutUrl();
			// if(_currentUser?.local === false) {
			// 	location.href = ApplicationData.locationConfiguration.getADFSLogoutUrl();
			// }
			// else {
			// 	location.href = LS2PAC_CONSTANTS.restUrls.logout;
			// }
		} else {
			var logoutData = null;
			TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.logout, {
				dataType: "text",
				callback: (text) => {
					var data = text ? JSON.parse(text) : null;
					success = true;
					clearAccountData();
					clearSearchHistory();
					logoutData = data;
				},
				finallyHandler: () => {

					if (logoutData && logoutData.cas && logoutData.redirect) {
						window.location.replace(logoutData.redirect);
					} else {
						if (callback) callback(success);
						TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onLogoutResponse, { success: success });
						if (clearHistory) {
							HistoryManager.clear();
						}
					}

				},
				cache: false
			});
		}
	};


	var _promptIfNotLoggedIn = async function (callback, closeCallback, to=null, from=null) {
		//clear the callback on succesful login and/or cancel/close

			const { isAuthenticated, user } = await AccountHolder.fetchAccountData();
			if (!isAuthenticated) {
				currentLoginCallback = callback;
				currentCloseCallback = closeCallback;
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onPromptForLogin, {to, from});
			}
			else if (callback) {
				callback(user);
			}
			
	};

	BaseView.prototype.promptIfNotLoggedIn = function (callback, closeCallback) {
		_promptIfNotLoggedIn(callback, closeCallback);
	};


	return {
		promptIfNotLoggedIn: function (callback, closeCallback, to=null, from=null) {
			_promptIfNotLoggedIn(callback, closeCallback, to, from);
		},
		onLogout: function (callback, clearHistory) {
			_onLogout(callback, clearHistory);
		}
	};

})();
